export const CHECKOUT_URL =
  'https://mega-pack-control-de-acceso-y-cerraduras-inteligentes.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/oPDRZ1Kw56ZYUquWWrzWiT/Imagen_de_Codex_20_sept_2026,_21_03_33.png'

export const PRODUCT_NAME =
  'MEGA PACK CONTROL DE ACCESO Y CERRADURAS INTELIGENTES'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos sobre cerraduras, RFID, biometría, electroimanes y controladores, pero cada uno explica algo diferente y no sabes cómo conectar todo.',
  },
  {
    icon: 'question' as const,
    title: 'NO SABES QUÉ APRENDER PRIMERO',
    desc: 'Cerraduras inteligentes, lectores, relés, fuentes, RFID, biometría, apps, Wi-Fi... hay tantos componentes y tecnologías que empezar parece complicado.',
  },
  {
    icon: 'route' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Quieres aprender una habilidad técnica que puedas convertir en un nuevo servicio, pero necesitas un camino que vaya desde los fundamentos hasta la instalación y el diagnóstico.',
  },
  {
    icon: 'clock' as const,
    title: 'SIGUES POSTERGANDO',
    desc: 'Quieres comenzar, pero pasan las semanas y continúas buscando información en lugar de avanzar con un método organizado.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'book' as const,
    title: 'FUNDAMENTOS DEL CONTROL DE ACCESO',
    desc: 'Comprende cómo funciona un sistema de acceso, identificación, autenticación, autorización, credenciales, lectores, controladores y tecnologías como PIN, RFID, biometría y aplicaciones.',
  },
  {
    icon: 'lock' as const,
    title: 'CERRADURAS DIGITALES E INTELIGENTES',
    desc: 'Conoce los principales tipos de cerraduras inteligentes, compatibilidad con puertas, instalación, configuración de usuarios, PIN, tarjetas, huellas, aplicaciones y mantenimiento.',
  },
  {
    icon: 'fingerprint' as const,
    title: 'RFID, BIOMETRÍA, TECLADOS Y CONTROLADORES',
    desc: 'Comprende lectores RFID, teclados autónomos, biometría, controladores, relés, COM/NO/NC, pulsadores de salida y sensores de puerta.',
  },
  {
    icon: 'zap' as const,
    title: 'ELECTRICIDAD, ELECTROIMANES Y CABLEADO',
    desc: 'Aprende los fundamentos eléctricos necesarios para comprender fuentes, alimentación, respaldo, electroimanes, cerraderos eléctricos, cableado y diagnóstico.',
  },
  {
    icon: 'wifi' as const,
    title: 'VIDEOPORTEROS, APPS, WI-FI Y CONECTIVIDAD',
    desc: 'Comprende videoporteros, apertura autorizada, aplicaciones, redes, Wi-Fi, conectividad, permisos, acceso remoto y diagnóstico de problemas de comunicación.',
  },
  {
    icon: 'wrench' as const,
    title: 'DIAGNÓSTICO, CASOS REALES Y NEGOCIO',
    desc: 'Aprende un método ordenado para diagnosticar fallas, resolver casos de práctica, preparar presupuestos y comenzar a estructurar tu servicio profesional.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'clipboard' as const,
    title: 'KIT PRO DEL INSTALADOR™',
    desc: '15 plantillas profesionales para relevamientos, inspección de puertas, herramientas, materiales, instalación, configuración, pruebas, diagnóstico, órdenes de trabajo, entrega, mantenimiento y presupuestos.',
    value: 'Valor: $7.990',
  },
  {
    icon: 'network' as const,
    title: 'BIBLIOTECA PRO DE DIAGRAMAS™',
    desc: 'Una colección visual para comprender arquitecturas, cerraduras, lectores, controladores, relés, electroimanes, cerraderos, fuentes, sensores, videoporteros y conectividad.',
    value: 'Valor: $5.990',
  },
  {
    icon: 'search' as const,
    title: 'DIAGNÓSTICO PRO: 50 FALLAS, CAUSAS Y SOLUCIONES™',
    desc: '50 situaciones de práctica organizadas mediante síntoma, posibles causas, inspección, comprobación, diagnóstico, corrección y prueba final.',
    value: 'Valor: $6.990',
  },
  {
    icon: 'calculator' as const,
    title: 'INSTALADOR RENTABLE™',
    desc: 'Calculadoras, presupuestos y herramientas para aprender a organizar materiales, mano de obra, costos, precios, márgenes y rentabilidad de cada servicio.',
    value: 'Valor: $8.990',
  },
  {
    icon: 'target' as const,
    title: 'RETO 14 DÍAS: DE ALUMNO A INSTALADOR™',
    desc: 'Un plan de acción paso a paso para organizar tus servicios, practicar, crear tu portafolio, preparar presupuestos y comenzar a buscar tus primeras oportunidades.',
    value: 'Valor: $9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'compass' as const,
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre contenidos y sigue una ruta desde los fundamentos hasta la instalación, configuración y diagnóstico.',
  },
  {
    icon: 'wrench' as const,
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprende cerraduras inteligentes, RFID, biometría, controladores, electroimanes, cableado, videoporteros, apps y conectividad con explicaciones organizadas.',
  },
  {
    icon: 'door' as const,
    title: 'COMPRENDE LO QUE ESTÁS VIENDO',
    desc: 'Empieza a mirar una puerta o un sistema de acceso y reconocer qué componentes intervienen, cómo se relacionan y qué función cumple cada uno.',
  },
  {
    icon: 'rocket' as const,
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construye conocimientos que pueden convertirse en el primer paso para incorporar un nuevo servicio técnico y ampliar tus posibilidades profesionales.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Había visto muchos videos de cerraduras inteligentes y controles RFID, pero seguía sin entender cómo se relacionaban los componentes. Con los tomos ordenados finalmente entendí la lógica entre lector, controlador, relé y cerradura.',
    author: 'Diego Fernández',
    role: 'Técnico en formación, 29 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Lo que más me ayudó fue entender que no todo es instalar una cerradura. Hay que revisar la puerta, alimentación, compatibilidad y configuración. Ahora puedo analizar un sistema con mucho más orden antes de pensar en instalar.',
    author: 'Marcelo Ibáñez',
    role: 'Instalador de CCTV, 41 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Trabajo con electricidad y quería sumar control de acceso, pero no sabía qué estudiar primero. El sistema me ayudó a conectar la parte eléctrica con lectores, controladores, electroimanes y cerraderos.',
    author: 'Laura Quiroga',
    role: 'Electricista, 35 años',
    location: 'Montevideo, Uruguay',
  },
  {
    quote:
      'Entré buscando aprender cerraduras inteligentes y terminé entendiendo también diagnóstico. Las 50 fallas me obligaron a pensar primero en el síntoma, después en las causas y recién entonces buscar una solución.',
    author: 'Cristian Molina',
    role: 'Técnico independiente, 32 años',
    location: 'Santiago, Chile',
  },
  {
    quote:
      'Quería agregar un servicio nuevo a lo que ya hacía. Las plantillas, los presupuestos y el reto de 14 días me dieron una estructura mucho más clara para organizarme y practicar antes de ofrecerlo.',
    author: 'Héctor Ramírez',
    role: 'Cerrajero, 48 años',
    location: 'Guadalajara, México',
  },
]

/* 6. FAQ */
export const faqs = [
  {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% digital.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema comienza con los fundamentos y avanza progresivamente hacia instalación, configuración, conectividad y diagnóstico.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Aprenderás fundamentos de control de acceso, cerraduras inteligentes, RFID, biometría, teclados, controladores, electricidad aplicada, electroimanes, cableado, videoporteros, apps, Wi-Fi, diagnóstico y organización del servicio.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Encontrarás ejercicios, casos de práctica, checklists, diagramas, fallas simuladas y actividades de aplicación.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos indicados están incluidos con tu compra.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizas un único pago para acceder al producto adquirido, según las condiciones de la oferta.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Al confirmarse el pago recibirás las instrucciones para acceder al contenido digital.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es un producto educativo y no reemplaza licencias, certificaciones, permisos, formación oficial o habilitaciones exigidas en tu jurisdicción.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes avanzar por los tomos siguiendo tu propio ritmo y volver a consultar el material.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes comunicarte mediante el canal de soporte indicado en esta página.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Martín Gómez', city: 'Córdoba', minutes: 3 },
  { name: 'Lucía Ferreyra', city: 'Rosario', minutes: 6 },
  { name: 'Pablo Sosa', city: 'Buenos Aires', minutes: 9 },
  { name: 'Andrés Medina', city: 'Mendoza', minutes: 13 },
  { name: 'Sofía Ledesma', city: 'La Plata', minutes: 17 },
  { name: 'Javier Rossi', city: 'Mar del Plata', minutes: 21 },
  { name: 'Nicolás Barrios', city: 'Salta', minutes: 26 },
  { name: 'Camila Vera', city: 'San Miguel de Tucumán', minutes: 31 },
]
